import { useLingui } from '@lingui/react';
import type { MenuProps } from 'antd';
import { Button, Dropdown } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { dynamicActivate } from 'utils/i18n';

const StyledButton = styled(Button)`
  vertical-align: middle;
  display: flex;
  text-transform: uppercase;
  padding: 0;
  span {
    padding-top: 3px;
    padding-right: 20px;
  }
  svg {
    width: 25px;
    height: 25px;
    margin: 0 0 0 10px;
  }
`;

export const LocaleToggle = () => {
  const { i18n } = useLingui();

  const items: MenuProps['items'] = [
    {
      key: 'sk',
      label: (
        <Button type="link" onClick={() => dynamicActivate('sk')}>
          SK
        </Button>
      ),
    },
    {
      key: 'en',
      label: (
        <Button type="link" onClick={() => dynamicActivate('en')}>
          EN
        </Button>
      ),
    },
  ];

  return (
    <Dropdown
      menu={{
        items,
        selectable: false,
      }}
      trigger={['click']}
    >
      <StyledButton className="ant-dropdown-link" type="text">
        {i18n.locale}
      </StyledButton>
    </Dropdown>
  );
};
